import {
  GetDocumentTemplateVersionExtendsOptions,
  IDocumentTemplateVersion,
} from '@commenda/types/src/document-generation';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';

interface UseDocumentTemplateVersionsResponse {
  data: IDocumentTemplateVersion[];
  count: number;
}

export const useDocumentTemplateVersions = (
  documentTemplateId: string | undefined,
  queryParams?: { extends?: GetDocumentTemplateVersionExtendsOptions[] }
) => {
  const query = new URLSearchParams();
  if (queryParams?.extends) {
    queryParams.extends.forEach(
      (ext: GetDocumentTemplateVersionExtendsOptions) =>
        query.append('extends', ext)
    );
  }

  const queryString = query.toString();
  const url = documentTemplateId
    ? `${BASE_URL}/${documentTemplateId}/versions${queryString ? `?${queryString}` : ''}`
    : null;

  const { data, error, isLoading, mutate } =
    useSWR<UseDocumentTemplateVersionsResponse>(
      url,
      SWRFetcher({
        method: 'GET',
      })
    );

  return { data, error, isLoading, mutate };
};
